<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
        [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
        style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    @if (loading) {
      <div class="formLoader">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    }

    <!-- ── Step 1: Rule Form ── -->
    @if (step === 1) {
      <div class="step-content">
        @if (mode === 'edit') {
          <div class="form-group">
            <label class="field-label">Rule Id</label>
            <input class="form-control" [value]="ruleModel.RULE_KEY" disabled />
          </div>
        }
        <div class="form-group">
          <label class="field-label">Rule Name</label>
          <input class="form-control" [(ngModel)]="ruleModel.RULE_NAME" />
        </div>
        <div class="form-group">
          <label class="field-label">Rule Description</label>
          <input class="form-control" [(ngModel)]="ruleModel.RULE_DESC" />
        </div>
        <div class="form-group">
          <label class="field-label">Rule Path</label>
          <input class="form-control" [(ngModel)]="ruleModel.RULE_PATH" />
        </div>
        <div class="form-group">
          <label class="field-label">Rule Active</label>
          <select class="form-control" [(ngModel)]="ruleModel.RULE_ACTIVE_FLAG">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
    }

    <!-- ── Step 2: Actions ── -->
    @if (step === 2) {
      <div class="step-content">
        <div class="inline-add-row">
          <input class="form-control add-input" [(ngModel)]="newActionKey" placeholder="Action key" />
          <button class="btn btn-success btn-xs" type="button" (click)="addAction()">
            <i class="fa fa-search"></i> Add Action
          </button>
        </div>

        <table class="table table-bordered rule-table">
          <thead>
            <tr>
              <th>Action Key</th>
              <th>Action Code</th>
              <th>Action Name</th>
              <th>Action DS</th>
              <th>Action Proc</th>
              <th>Active ?</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (action of allLinkedActions; track $index) {
              <tr>
                <td>{{ action.action_key }}</td>
                <td>{{ action.action_code }}</td>
                <td>{{ action.action_name }}</td>
                <td>{{ action.action_datasource }}</td>
                <td>{{ action.action_proc }}</td>
                <td>{{ action.action_validation_status == 1 ? 'Yes' : 'No' }}</td>
                <td class="text-center">
                  @if (action.action_validation_status == 1) {
                    <i
                      class="fa fa-times-circle text-danger action-icon"
                      ap-tooltip [appendAfterTarget]="true" tooltipContent="Delink Action" direction="left"
                    (click)="linkDelinkAction(action)"></i>
                  }
                  @if (action.action_validation_status != 1) {
                    <i
                      class="fa fa-plus-circle text-success action-icon"
                      ap-tooltip [appendAfterTarget]="true" tooltipContent="Link Action" direction="left"
                    (click)="linkDelinkAction(action)"></i>
                  }
                </td>
              </tr>
            }
            @if (allLinkedActions.length === 0) {
              <tr>
                <td colspan="7" class="no-data">No Linked Action</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- ── Step 3: Cache ── -->
    @if (step === 3) {
      <div class="step-content">
        <div class="inline-add-row">
          <input class="form-control add-input" [(ngModel)]="newCacheObjectKey" placeholder="Cache key" />
          <button class="btn btn-success btn-xs" type="button" (click)="addCacheObject()">
            <i class="fa fa-search"></i> Add Cache
          </button>
        </div>

        <table class="table table-bordered rule-table">
          <thead>
            <tr>
              <th>Cache Key</th>
              <th>Object Key</th>
              <th>Cache Proc</th>
              <th>Filter Condition</th>
              <th>Is Cached?</th>
              <th>Is Stale?</th>
              <th>Status</th>
              <th>Last Updated?</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (cache of allLinkedCacheObjects; track $index) {
              <tr>
                <td>{{ cache.cache_key }}</td>
                <td>{{ cache.object_key }}</td>
                <td>{{ cache.cache_proc_call }}</td>
                <td>{{ cache.object_filter_condition }}</td>
                <td>{{ cache.is_cached }}</td>
                <td>{{ cache.is_stale }}</td>
                <td>{{ cache.cache_status }}</td>
                <td>{{ cache.last_updated }}</td>
                <td class="text-center">
                  <i class="fa fa-times-circle text-danger action-icon"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Delink Cache Object" direction="left"
                  (click)="delinkCacheObject(cache)"></i>
                </td>
              </tr>
            }
            @if (allLinkedCacheObjects.length === 0) {
              <tr>
                <td colspan="9" class="no-data">No Linked Cache Object</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer" [hidden]="minimise">
    @if (step === 1) {

      <button class="btn btn-success btn-sm" type="button" [disabled]="loading" (click)="saveAndNext()">
        @if (loading) {
          <span><i class="fa fa-spinner fa-pulse"></i></span>
          } Save &amp; Next
        </button>
        <button class="btn btn-info btn-sm" type="button" [disabled]="loading || mode === 'new'" (click)="goNext()">Next</button>

      }
      @if (step === 2) {

        <button class="btn btn-info btn-sm" type="button" (click)="goBack()">Back</button>
        <button class="btn btn-info btn-sm" type="button" (click)="goNext()">Next</button>

      }
      @if (step === 3) {

        <button class="btn btn-info btn-sm" type="button" (click)="goBack()">Back</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="end()">End</button>

      }
    </div>
  </div>
